import { useEffect, useRef, useState } from 'react'

const Turnstile = ({ onVerify, onError, onExpire, className = '' }) => {
  const turnstileRef = useRef(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const [widgetId, setWidgetId] = useState(null)

  useEffect(() => {
    // Load Turnstile script if not already loaded
    if (!window.turnstile) {
      const script = document.createElement('script')
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
      script.async = true
      script.defer = true
      script.onload = () => setIsLoaded(true)
      document.head.appendChild(script)
    } else {
      setIsLoaded(true)
    }

    return () => {
      // Cleanup widget on unmount
      if (widgetId && window.turnstile) {
        window.turnstile.remove(widgetId)
      }
    }
  }, [widgetId])

  useEffect(() => {
    if (isLoaded && turnstileRef.current && !widgetId) {
      const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY
      
      if (!siteKey) {
        console.error('VITE_TURNSTILE_SITE_KEY environment variable is not set')
        return
      }

      try {
        const id = window.turnstile.render(turnstileRef.current, {
          sitekey: siteKey,
          callback: (token) => {
            onVerify?.(token)
          },
          'error-callback': (error) => {
            console.error('Turnstile error:', error)
            onError?.(error)
          },
          'expired-callback': () => {
            onExpire?.()
          },
          theme: 'light',
          size: 'normal'
        })
        setWidgetId(id)
      } catch (error) {
        console.error('Failed to render Turnstile:', error)
        onError?.(error)
      }
    }
  }, [isLoaded, onVerify, onError, onExpire, widgetId])

  const reset = () => {
    if (widgetId && window.turnstile) {
      window.turnstile.reset(widgetId)
    }
  }

  // Expose reset method to parent components
  useEffect(() => {
    if (turnstileRef.current) {
      turnstileRef.current.reset = reset
    }
  }, [widgetId])

  return (
    <div className={className}>
      <div ref={turnstileRef}></div>
    </div>
  )
}

export default Turnstile 